define('bizzabo/models/TopEntities',['backbone', 'bizzabo/bzapi'], function(Backbone, BZAPI) {

    var TopEntities = Backbone.Collection.extend({

        defaultCount : 5,

        sync : function(method, model, options) {
            if (method == 'read') {
                BZAPI.getTopEntities(model.eventId, model.entityName, model.length, model.defaultCount, model.sortAttribute, function(data) {
                    options.success && options.success(data[model.entityNameAttribute], options);
                }, options.error);
            }
        }

    });

    return TopEntities;

});
